export default __webpack_public_path__ + "static/bisballsleep-849ea9b0c556ecffdb91710a085be157.png";